angular.module('bb.util').factory('ToastService', ToastService);

ToastService.$inject = ['$timeout'];
function ToastService($timeout) {
  const toasts = [];

  // example: ToastService.add({ message: 'Hello', type: 'success', removeAfter: 20 })
  // Add takes an Object that has the following three params
  //    type: the type of alert, can be on of
  //          success, info, warning, danger, primary
  //    removeAfter: if needed you can explicitly ask the service to
  //          keep the toast around for a specified ammount of time. If this is not set it defaults to
  //          10 seconds
  //    message: String to be shown

  // Returns: a unique id for the toast. If you would like to programatically remove the toast
  //          i.e.  let id = ToastService.add({...}); .... ; ToastService.remove(id)
  function add(toast) {
    toast.id = `_${Math.random().toString(36).substr(2, 9)}`;
    toast.timeout = $timeout(
      function () {
        remove(toast.id);
      },
      toast.removeAfter * 1000 || 6000,
    );
    toasts.push(toast);
    return toast.id;
  }

  function remove(id) {
    const index = toasts.findIndex(t => {
      return t.id === id;
    });
    if (index > -1) {
      $timeout.cancel(toasts[index].timeout);
      toasts.splice(index, 1);
    }
  }
  return {
    add,
    remove,
    toasts,
  };
}

export {};
